'use strict';

import React from 'react';
import Sidebar from '../organisms/Sidebar';
import OverlayStore from '../stores/OverlayStore';
import SidebarTypes from '../constants/SidebarTypes';
import createStoreMixin from '../mixins/createStoreMixin';
import PureRenderMixin from '../mixins/PureRenderMixin';
import PinterestPicker from '../sidebar/PinterestPicker';
import StampOtherZines from '../sidebar/StampOtherZines';
import AddStampToZines from '../sidebar/AddStampToZines';
import AddStampsToZine from '../sidebar/AddStampsToZine';
import ApprovePendingStamp from '../sidebar/ApprovePendingStamp';
import RejectPendingStamp from '../sidebar/RejectPendingStamp';
import ZinePendingStamps from '../sidebar/ZinePendingStamps';
import Activities from '../sidebar/Activities';
import StampLikes from '../sidebar/StampLikes';
import UserSubscribers from '../sidebar/UserSubscribers';
import UserSubscriptions from '../sidebar/UserSubscriptions';
import ImageUsedInStamps from '../sidebar/ImageUsedInStamps';
import Drafts from '../sidebar/Drafts';
import LeaveDraftFeedback from '../sidebar/LeaveDraftFeedback';
import DraftFeedbacks from '../sidebar/DraftFeedbacks';

const SidebarHost = React.createClass({
  mixins: [createStoreMixin(OverlayStore), PureRenderMixin],

  getStateFromStores() {
    return {
      sidebar: OverlayStore.getSidebar()
    };
  },

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.sidebar && this.state.sidebar) {
      this.getDOMNode().scrollTop = 0;
    }
  },

  render() {
    return (
      <Sidebar active={!!this.state.sidebar}>
        {this.renderBody(this.state.sidebar)}
      </Sidebar>
    );
  },

  renderBody(sidebar) {
    if (!sidebar) {
      return null;
    }

    switch (sidebar.id) {
    case SidebarTypes.PINTEREST_PICKER:
      return (
        <PinterestPicker stampId={sidebar.stampId} />
      );

    case SidebarTypes.STAMP_OTHER_ZINES:
      return (
        <StampOtherZines stampId={sidebar.stampId}
                         zineSlugs={sidebar.zineSlugs} />
      );

    case SidebarTypes.ADD_STAMP_TO_ZINES:
      return (
        <AddStampToZines stampId={sidebar.stampId} />
      );

    case SidebarTypes.ADD_STAMPS_TO_ZINE:
      return (
        <AddStampsToZine zineSlug={sidebar.zineSlug} />
      );

    case SidebarTypes.ZINE_PENDING_STAMPS:
      return (
        <ZinePendingStamps zineSlug={sidebar.zineSlug} />
      );

    case SidebarTypes.APPROVE_PENDING_STAMP:
      return (
        <ApprovePendingStamp stampId={sidebar.stampId}
                             zineSlug={sidebar.zineSlug} />
      );

    case SidebarTypes.REJECT_PENDING_STAMP:
      return (
        <RejectPendingStamp stampId={sidebar.stampId}
                            zineSlug={sidebar.zineSlug} />
      );

    case SidebarTypes.ACTIVITIES:
      return (
        <Activities />
      );

    case SidebarTypes.STAMP_LIKES:
      return (
        <StampLikes stampId={sidebar.stampId} />
      );

    case SidebarTypes.USER_SUBSCRIBERS:
      return (
        <UserSubscribers userId={sidebar.userId} />
      );

    case SidebarTypes.USER_SUBSCRIPTIONS:
      return (
        <UserSubscriptions userId={sidebar.userId} />
      );

    case SidebarTypes.IMAGE_USED_IN_STAMPS:
      return (
        <ImageUsedInStamps imageUuid={sidebar.imageUuid}
                           excludeStampId={sidebar.excludeStampId} />
      );

    case SidebarTypes.DRAFTS:
      return (
        <Drafts />
      );

    case SidebarTypes.LEAVE_DRAFT_FEEDBACK:
      return (
        <LeaveDraftFeedback draftUuid={sidebar.draftUuid} />
      );

    case SidebarTypes.DRAFT_FEEDBACKS:
      return (
        <DraftFeedbacks draftUuid={sidebar.draftUuid} />
      );

    default:
      console.warn('Unsupported sidebar', sidebar.id);
    }
  }
});

export default SidebarHost;


/** WEBPACK FOOTER **
 ** ./hosts/SidebarHost.jsx
 **/